import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Icon } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { settingsPosTrackingMethodLocationsPath } from '../../../../routes/Paths';
import { toggleSidebarNav } from '../../../../redux/Settings/actions';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { getSidebarNavExpanded } from '../../../../redux/Settings/selectors/components/page-layout';
import { viewAccess } from '../../../../helpers/permission';
import MainLayout from '../../../../containers/MainLayout';
import MainContent from '../../../MainContent';
import SidebarNav from '../../../SidebarNav';
import AccessControl from '../../../AccessControl';
import NavLink from '../../../NavLink';
import { NAV_KEYS } from './nav-keys';

const PageLayout = ({ children }) => {
  const dispatch = useDispatch();
  const [activeKey] = useState(NAV_KEYS.POS_TRACKING_METHOD_LOCATIONS);
  const sidebarExpanded = useSelector(getSidebarNavExpanded);

  const handleToggleSidebarNav = () => {
    dispatch(toggleSidebarNav());
  };

  return (
    <MainLayout>
      <MainContent>
        <SidebarNav
          activeKey={activeKey}
          expanded={sidebarExpanded}
          onToggle={handleToggleSidebarNav}
        >
          <AccessControl allowOnlyFor={viewAccess(PERMISSIONS.POS)}>
            <NavLink
              to={settingsPosTrackingMethodLocationsPath}
              eventKey={NAV_KEYS.POS_TRACKING_METHOD_LOCATIONS}
              icon={<Icon icon="list-alt" />}
            >
              Tracking Method Locations
            </NavLink>
          </AccessControl>
        </SidebarNav>
        <Container>{children}</Container>
      </MainContent>
    </MainLayout>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageLayout;
